import { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  TextField,
} from '@mui/material';
// component
import Iconify from '../../components/Iconify';
import { deleteDevice } from '../../api/devices';

// ----------------------------------------------------------------------
export default function DeviceMoreMenu({handleDialog,handleMoremenu, row, handleAlertOpen, removeDeviceFromState}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [showDeleteReasonError, setShowDeleteReasonError] = useState(false);

  const openMoreMenu = (row) => {
    toggleActionMenu(false);
    handleMoremenu(row);
  }

  const openDialogMenu = (row) => {
    toggleActionMenu(false);
    handleDialog(row);
  }

  const openAlertMenu = (e, row, status) => {
    toggleActionMenu(false);
    handleAlertOpen(e, row, status)
  }

  const openDeleteDialog = () => {
    toggleActionMenu(false);
    setDeleteReason('');
    setShowDeleteReasonError(false);
    setIsDeleteDialogOpen(true);
  }

  const closeDeleteDialog = () => {
    if (isDeleting) return;
    setDeleteReason('');
    setShowDeleteReasonError(false);
    setIsDeleteDialogOpen(false);
  }

  const handleDeleteDevice = () => {
    if (!deleteReason.trim()) {
      setShowDeleteReasonError(true);
      return;
    }

    setIsDeleting(true);
    deleteDevice(
      {
        deviceid: row.deviceid,
        DeleteCommentReason: deleteReason.trim(),
      },
      (response) => {
        setIsDeleting(false);
        if (response.status === 200) {
          setDeleteReason('');
          setShowDeleteReasonError(false);
          setIsDeleteDialogOpen(false);
          removeDeviceFromState(row.deviceid);
        }
      }
    );
  }

  const toggleActionMenu = (val) => {
    setIsOpen(val);
  }

  return (
    <>
      <IconButton ref={ref} onClick={() => toggleActionMenu(true)}>
        <Iconify icon="eva:more-vertical-fill" width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => toggleActionMenu(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' },
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem sx={{ color: 'text.secondary' }} onClick={() => openMoreMenu(row)} >
          <ListItemIcon>
            <Iconify icon="eva:menu-fill" width={24} height={24}/>
          </ListItemIcon>
          <ListItemText primary="More Details" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem component={RouterLink} to="#" sx={{ color: 'text.secondary' }} onClick={() => openDialogMenu(row)}>
          <ListItemIcon>
            <Iconify icon="eva:edit-fill" width={24} height={24}/>
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem sx={{ color: 'text.secondary' }} onClick={(e) => openAlertMenu(e,row,'status')} >
          <ListItemIcon>
            <Iconify icon="eva:flip-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Change Status" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }} onClick={openDeleteDialog} >
          <ListItemIcon>
            <Iconify icon="eva:trash-2-outline" width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

      </Menu>

      <Dialog open={isDeleteDialogOpen} onClose={closeDeleteDialog} fullWidth maxWidth="sm">
        <DialogTitle>Are you sure you want to delete this device?</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={1.5}>
            <Typography variant="body2">
              <strong>Device ID:</strong> {row.deviceid}
            </Typography>
            <Typography variant="body2">
              <strong>Device Name:</strong> {row.devicename || '-'}
            </Typography>
            <TextField
              fullWidth
              multiline
              minRows={3}
              required
              label="Delete Reason"
              placeholder="Enter reason for deleting this device"
              InputLabelProps={{ shrink: true }}
              value={deleteReason}
              onChange={(event) => {
                setDeleteReason(event.target.value);
                if (showDeleteReasonError && event.target.value.trim()) {
                  setShowDeleteReasonError(false);
                }
              }}
              error={showDeleteReasonError}
              helperText={showDeleteReasonError ? 'Delete reason is required' : ' '}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteDialog} disabled={isDeleting}>
            No
          </Button>
          <Button onClick={handleDeleteDevice} color="error" variant="contained" disabled={isDeleting}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
